export default __webpack_public_path__ + "static/media/schedule.dfa84d5f.svg";